<template>
  <div class="simple-certification-tile simple-certification-tile__acctionable">
    <div class="simple-certification-tile__wrapper" @click="handleTileClick">
      <div>
        <div class="simple-certification-tile__top">
          <div v-if="version" class="simple-certification-tile__version">
            {{ version }}
          </div>
        </div>
        <div
          :class="[
            'simple-certification-tile__badge',
            version && 'simple-certification-tile__badge--versioned',
          ]"
        >
          <img
            class="simple-certification-tile__badge-logo"
            :src="certification.logo"
          />
        </div>
        <h3 class="simple-certification-tile__title">
          {{ certification.title }}
        </h3>
        <h3 class="simple-certification-tile__description">
          {{ certification.description }}
        </h3>
      </div>
      <a
        :href="`${certification.url}`"
        target="_blank"
        rel="noopener nofollow"
        class="btn btn--secondary simple-certification-tile__button"
      >
        Shop vouchers
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimpleCertificationTile',
  props: {
    certification: {
      type: Object,
      required: true,
    },
  },
  computed: {
    version() {
      return this.certification.version ? `V${this.certification.version}` : ''
    },
  },
  methods: {
    handleTileClick() {
      if (this.certification.url) {
        window.open(this.certification.url, '_blank')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.simple-certification-tile {
  $this: &;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  background: linear-gradient(
    104.99deg,
    rgba(62, 63, 73, 0.7) -13.91%,
    rgba(62, 63, 73, 0) 100.48%
  );
  border-radius: 10px;
  @include mobile {
    width: calc(50% - 10px);
  }
  @include tablet {
    width: calc(33% - 10px);
  }
  &__acctionable {
    cursor: pointer;
  }
  &__wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0px 30px 30px 30px;
    justify-content: space-between;
    @include tablet {
      min-height: 647px;
    }
  }
  &:hover {
    transition: 0.3s;
    background-color: rgb(255 255 255 / 5%);
    #{$this}__button {
      border: 1px solid var(--btn-hover-border-color) !important;
    }
  }
  &__top {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    align-self: flex-end;
    margin-top: 30px;
  }
  &__version {
    position: relative;
    box-sizing: border-box;
    background: linear-gradient(
      111.02deg,
      rgba(18, 18, 18, 0.7) 3.86%,
      rgba(18, 18, 18, 0) 107.96%
    );
    border-radius: 20px;
    color: var(--white);
    text-transform: uppercase;
    padding: 9px 14px;
    font-size: 12px;
    line-height: 14px;
    &:before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: -1;
      margin: -2px; /* !importanté */
      border-radius: inherit; /* !importanté */
      background: linear-gradient(
        111.02deg,
        #3e3f49b2 3.86%,
        #3e3f4900 107.96%
      );
    }
  }
  &__badge {
    display: flex;
    justify-content: center;
    margin-top: 10px;
    &-logo {
      width: 75%;
    }
    &--versioned {
      margin-top: -20px;
    }
  }
  &__title {
    font-weight: bold;
    font-size: 20px;
    line-height: 26px;
    display: flex;
    align-items: center;
    color: var(--white);
    margin-top: 20px;
    min-height: 51.98px;
  }
  &__description {
    font-size: 14px;
    line-height: 20px;
    color: var(--light-blue-gray);
  }
  &__button {
    align-self: flex-end;
  }
}
</style>
